
import { useState } from "react";

import { X } from "lucide-react";

import { SURVEY_URL } from "../../../lib/config";

import { Button } from "../../../components/button";

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "../../../components/dialog";

export function Share() {

  const [ isOpen, setIsOpen ] = useState( false );

  const [ isCopied, setIsCopied ] = useState( false );

  const copyTextToClipboard = async () => {

    try {

      await navigator.clipboard.writeText( SURVEY_URL );

      setIsCopied( true );

      setTimeout( () => setIsOpen( false ), 1500 );

      setTimeout( () => setIsCopied( 'false' ), 1600 );
        
    } catch ( err ) {

      console.error( 'Failed to copy text: ', err );

    }

  }
  
  return (

    <>

      <div className="bg-blue-fresh flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 p-8 sm:p-10 mx-auto max-w-4xl">

        <div>

          <h3 className="font-bold text-xl xs:text-3xl text-white">Pass This to a Colleague</h3>

          <p className="xs:text-xl text-white">Share this survey and keep your team in the loop.</p>

        </div>

        <Button className="w-max" variant="secondary" onClick={ () => setIsOpen( true ) }>

          Share Survey

        </Button>

      </div>
    
      <Dialog open={ isOpen } onClose={ () => setIsOpen( false ) }>

        <DialogBackdrop />

        <div className="fixed inset-0 flex w-screen items-center justify-center p-0 sm:p-4">

          <DialogPanel className="relative max-w-4xl">

            <DialogTitle className="max-w-9/10">Click the button to copy this link and share with a colleague.</DialogTitle>

            <div className="col-start-1 flex items-center text-left bg-grey-abalaster border border-input min-h-13 px-4 py-1">

              <p className="text-black wrap-anywhere md:whitespace-nowrap">{ SURVEY_URL }</p>

            </div>

            <div className="flex items-center justify-center">

              <Button className="w-35 mt-4 sm:mt-0 capitalize" onClick={ copyTextToClipboard } variant="secondary">

                { isCopied ? 'copied!' : 'copy link' }

              </Button>

            </div>

            <Button 
            
              className="absolute top-0 right-0 m-2" 
              
              onClick={ () => setIsOpen( false ) } 
              
              size="icon" 
              
              title="Close panel" 
              
              variant="ghost"
              
            >

              <X className="size-5" />

            </Button>

          </DialogPanel>
          
        </div>

      </Dialog>

    </>

  )

}
